import React, { useState, useEffect } from 'react';
import { db, collection, doc, getDoc } from '../firebase';
import { siteData } from '../data/allBaseData';
import SiteDataContext from './SiteDataContext';

const SiteDataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const fetchedData = {};
        for (const key in siteData) {
          if (siteData.hasOwnProperty(key)) {
            const docRef = doc(collection(db, key), 'singleton');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
              fetchedData[key] = docSnap.data();
            } else {
              console.log(`No data found in Firestore for ${key}. Using local data.`);
              fetchedData[key] = siteData[key]; // Use local data as fallback
            }
          }
        }
        setData(fetchedData);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const value = {
    data,
    isLoading,
    error,
  };

  return (
    <SiteDataContext.Provider value={value}>
      {children}
    </SiteDataContext.Provider>
  );
};

export default SiteDataProvider; 